module.exports = __webpack_public_path__ + "img/brain-mental.87177eb4.svg";